module.exports = __webpack_public_path__ + "img/hero.5a3dfa23.png";